import Api from 'common/middleware/api';

export const DELETE_CHAPTER_ERROR = 'DELETE_CHAPTER_ERROR';
export function deleteChapterError(error) {
  return {
    error,
    type: DELETE_CHAPTER_ERROR,
  };
}

export const DELETE_CHAPTER_REQUEST = 'DELETE_CHAPTER_REQUEST';
export function deleteChapterRequest(chapter) {
  return {
    chapter,
    type: DELETE_CHAPTER_REQUEST,
  };
}

export const DELETE_CHAPTER_SUCCESS = 'DELETE_CHAPTER_SUCCESS';
export function deleteChapterSuccess(chapter) {
  return {
    chapter,
    type: DELETE_CHAPTER_SUCCESS,
  };
}

export const DELETE_CHAPTER = 'DELETE_CHAPTER';
export function deleteChapter(chapter) {
  return (dispatch) => {
    dispatch(deleteChapterRequest(chapter));
    return Api.deleteChapter(chapter)
      .then(Api.checkStatus)
      .then((response) => response.json())
      .then((success) => dispatch(deleteChapterSuccess(success)))
      .catch((error) => dispatch(deleteChapterError(error)));
  };
}
